import React from 'react';

const TriangleIconForIpr = (props) => {

  const position = (props.position === undefined || props.position === null ? "unset" : props.position)
  const left = (props.left === undefined || props.left === null ? "unset" : (props.left - 2))
  const top = (props.top === undefined || props.top === null ? "unset" : (props.top))
  const z = props.zIndex ? props.zIndex : 0;

  return (
    <div style={{
      width: "3px",
      height: "5px",
      left: left,
      top: top,
      position: position,
      visibility: props.visibility,
      display: "flex",
      justifyContent: "center",
      alignItems: props.direction === "up" ? "flex-end" : "flex-start",
      zIndex: z,
    }}>
      <div style={{
        width: "3px",
        height: "7px",
        borderTop: props.direction === "down" ? "7px solid #4B4B4B" : "0px",
        borderLeft: "2px solid transparent",
        borderRight: "2px solid transparent",
        borderBottom: props.direction === "up" ? "7px solid #4B4B4B" : "0px",
      }} />
    </div>
  );
};
 
export default TriangleIconForIpr;